// import logo from './logo.svg';
// import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from "./pages/Header";
import About from "./pages/About";
import OpenData from "./pages/OpenData";
import Dashboard from "./pages/Dashboard";
import PetaDigital from "./pages/PetaDigital";
import Statistik from "./pages/Statistik";
import Footer from "./pages/Footer";

import PagesBerandaOpenData from "./pages_2/open_data/PagesBerandaOpenData";
import PagesTentangaOpenData from "./pages_2/open_data/PagesTentangOpenData";
import PagesKumpulanDataOpenData from "./pages_2/open_data/PagesKumpulanDataOpenData";
import DetailDataCompOpenData from "./components/open_data/kumpulan_data/DetailDataCompOpenData";
import DetailDataBPS from "./components/open_data/kumpulan_data/DetailDataBPS";
import HeaderOpenData from "./pages_2/open_data/HeaderOpenData";
import FooterOpenData from "./pages_2/open_data/FooterOpenData";
import DetailResourceCompOpenData from "./components/open_data/kumpulan_data/DetailResourceCompOpenData";
import PagesKategoriOpenData from "./pages_2/open_data/PagesKategoriOpenData";
import PagesKategoriDetailOpenData from "./pages_2/open_data/PagesKategoriDetailOpenData";
import PagesOrganisasiOpenData from "./pages_2/open_data/PagesOrganisasiOpenData";
import PagesOrganisasiDetailOpenData from "./pages_2/open_data/PagesOrganisasiDetailOpenData";
import PagesInfografikOpenData from "./pages_2/open_data/PagesInfografikOpenData";


function App() {
  useEffect(() => {
    const data_var = () => {
      if (window.GLightbox && window.Swiper) {
        const select = (el, all = false) => {
          if (typeof el !== 'string' || el.trim() === '') {
            // console.error('Invalid selector:', el);
            return null;
          }
          el = el.trim()
          if (all) {
            return [...document.querySelectorAll(el)]
          } else {
            return document.querySelector(el)
          }
        }
        const on = (type, el, listener, all = false) => {
          let selectEl = select(el, all)
          if (selectEl) {
            if (all) {
              selectEl.forEach(e => e.addEventListener(type, listener))
            } else {
              selectEl.addEventListener(type, listener)
            }
          }
        }

        /**
         * Easy on scroll event listener 
         */
        const onscroll = (el, listener) => {
          el.addEventListener('scroll', listener)
        }

        /**
         * Navbar links active state on scroll
         */
        let navbarlinks = select('#navbar .scrollto', true)
        const navbarlinksActive = () => {
          let position = window.scrollY + 200
          navbarlinks.forEach(navbarlink => {
            if (!navbarlink.hash) return
            let section = select(navbarlink.hash)
            if (!section) return
            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
              navbarlink.classList.add('active')
            } else {
              navbarlink.classList.remove('active')
            }
          })
        }
        window.addEventListener('load', navbarlinksActive)
        onscroll(document, navbarlinksActive)

        /**
         * Scrolls to an element with header offset
         */
        const scrollto = (el) => {
          let header = select('#header')
          let offset = header.offsetHeight
          let elementPos = select(el).offsetTop
          window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
          })
        }

        /**
         * Toggle .header-scrolled class to #header when page is scrolled
         */
        let selectHeader = select('#header')
        if (selectHeader) {
          const headerScrolled = () => {
            if (window.scrollY > 100) {
              selectHeader.classList.add('header-scrolled')
            } else {
              selectHeader.classList.remove('header-scrolled')
            }
          }
          window.addEventListener('load', headerScrolled)
          onscroll(document, headerScrolled)
        }

        /**
         * Back to top button
         */
        let backtotop = select('.back-to-top')
        if (backtotop) {
          const toggleBacktotop = () => {
            if (window.scrollY > 100) {
              backtotop.classList.add('active')
            } else {
              backtotop.classList.remove('active')
            }
          }
          window.addEventListener('load', toggleBacktotop)
          onscroll(document, toggleBacktotop)
        }

        /**
         * Mobile nav toggle
         */
        on('click', '.mobile-nav-toggle', function (e) {
          select('#navbar').classList.toggle('navbar-mobile');
          this.classList.toggle('bi-list');
          this.classList.toggle('bi-x');
        })

        /**
         * Mobile nav dropdowns activate
         */
        on('click', '.navbar .dropdown > a', function (e) {
          if (select('#navbar').classList.contains('navbar-mobile')) {
            e.preventDefault()
            this.nextElementSibling.classList.toggle('dropdown-active')
          }
        }, true)

        /**
         * Scrool with ofset on links with a class name .scrollto
         */
        on('click', '.scrollto', function (e) {
          if (select(this.hash)) {
            e.preventDefault()

            let navbar = select('#navbar')
            if (navbar.classList.contains('navbar-mobile')) {
              navbar.classList.remove('navbar-mobile')
              let navbarToggle = select('.mobile-nav-toggle')
              navbarToggle.classList.toggle('bi-list')
              navbarToggle.classList.toggle('bi-x')
            }
            scrollto(this.hash)
          }
        }, true)

        /**
         * Scroll with ofset on page load with hash links in the url
         */
        window.addEventListener('load', () => {
          if (window.location.hash) {
            if (select(window.location.hash)) {
              scrollto(window.location.hash)
            }
          }
        });

        /**
         * Gallery Slider
         */
        new window.Swiper('.gallery-slider', {
          speed: 400,
          loop: true,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          slidesPerView: 'auto',
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            640: {
              slidesPerView: 4,
              spaceBetween: 30
            },
            992: {
              slidesPerView: 6,
              spaceBetween: 30
            },
            1200: {
              slidesPerView: 8,
              spaceBetween: 30
            }
          }
        });

        /**
         * Initiate gallery lightbox 
         */
        const galleryLightbox = window.GLightbox({
          selector: '.gallery-lightbox'
        });

        /**
         * Testimonials slider
         */
        new window.Swiper('.testimonials-slider', {
          speed: 600,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          slidesPerView: 'auto',
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 40
            },

            1200: {
              slidesPerView: 3,
              spaceBetween: 40
            }
          }
        });

        /**
         * Animation on scroll
         */
        /* window.addEventListener('load', () => {
          // eslint-disable-next-line no-undef
          AOS.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
            mirror: false
          });
        }); */
      }
    }
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        data_var();
      })
    })

    data_var();
    observer.observe(document.body, {
      parentList: true,
      childList: true,
      subtree: true,
    });

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);

  const formatDate = (dateStr) => {
    const [date, time] = dateStr.split('T');
    const formattedTime = time.split('.')[0];
    const date_x = new Date(`${date} ${formattedTime}`);
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };
    const dateString = date_x.toLocaleString('id-ID', options);

    // Mengganti " pukul " dengan spasi untuk menghilangkannya
    const formattedDate = dateString.replace(' pukul ', ' ').replace(/\./g, ':');

    return formattedDate;
    // return `${date} ${formattedTime}`;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div>
            <Header />
            <About />
            <main id="main">
              <OpenData />
              {/* <Dashboard /> */}
              <PetaDigital />
              <Statistik />
            </main>
            <Footer />
          </div>
        } />
        <Route path="/open_data" element={<PagesBerandaOpenData formatDate={formatDate} />} />
        <Route path="/open_data/infografik" element={<PagesInfografikOpenData />} />
        <Route path="/open_data/tentang" element={<PagesTentangaOpenData />} />
        <Route path="/open_data/kumpulan_data" element={<PagesKumpulanDataOpenData formatDate={formatDate} />} />
        <Route path="/open_data/kumpulan_data/:id" element={
          <div>
            <HeaderOpenData />
            <DetailDataCompOpenData formatDate={formatDate} />
            <FooterOpenData />
          </div>
        } />
        <Route path="/open_data/kumpulan_data/:id/resource/:id_resource" element={
          <div>
            <HeaderOpenData />
            <DetailResourceCompOpenData formatDate={formatDate} />
            <FooterOpenData />
          </div>
        } />
        <Route path="/open_data/bps_data/:tableId" element={
          <div>
            <HeaderOpenData />
            <DetailDataBPS formatDate={formatDate} />
            <FooterOpenData />
          </div>
        } />
        <Route path="/open_data/kategori" element={<PagesKategoriOpenData formatDate={formatDate} />} />
        <Route path="/open_data/kategori/:id_x" element={
          <div>
            <HeaderOpenData />
            <PagesKategoriDetailOpenData formatDate={formatDate} />
            <FooterOpenData />
          </div>
        } />
        <Route path="/open_data/organisasi" element={<PagesOrganisasiOpenData formatDate={formatDate} />} />
        {/* <Route path="/open_data/organisasi/:id_data" element={
          <div>
            <HeaderOpenData />
            <PagesOrganisasiDetailOpenData formatDate={formatDate} />
            <FooterOpenData />
          </div>
        } /> */}
        <Route
          path="/open_data/organisasi/:orgName"
          element={
            <div>
              <HeaderOpenData />
              <PagesOrganisasiDetailOpenData formatDate={formatDate} />
              <FooterOpenData />
            </div>
          }
        />
        
      </Routes>
    </Router>
  );
}

export default App;
